import { render, staticRenderFns } from "./SidebarBasic.vue?vue&type=template&id=4932c0dd&scoped=true"
import script from "./SidebarBasic.vue?vue&type=script&lang=js"
export * from "./SidebarBasic.vue?vue&type=script&lang=js"
import style0 from "./SidebarBasic.vue?vue&type=style&index=0&id=4932c0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932c0dd",
  null
  
)

export default component.exports